var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    style: {
      enableBackground: "new 0 0 34 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.5,23.1c0.1,0,0.2,0.1,0.2,0.1c0.2,0,0.3-0.1,0.4-0.2l3.5-3.3h6.5c1.4,0,2.6-1.2,2.6-2.6V9.8 c0-1.4-1.2-2.6-2.6-2.6h-12c-1.4,0-2.6,1.2-2.6,2.6v7.3c0,1.4,1.2,2.6,2.6,2.6h0.9v2.9C16.2,22.8,16.3,23,16.5,23.1z M15.2,18.4 c-0.7,0-1.4-0.6-1.4-1.4V9.8c0-0.7,0.6-1.4,1.4-1.4h12c0.7,0,1.4,0.6,1.4,1.4v7.3c0,0.7-0.6,1.4-1.4,1.4h-6.8 c-0.2,0-0.3,0.1-0.4,0.2l-2.6,2.5v-2c0-0.3-0.3-0.6-0.6-0.6L15.2,18.4L15.2,18.4L15.2,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,12.4h9c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6h-9c-0.3,0-0.6,0.3-0.6,0.6C16,12.1,16.3,12.4,16.6,12.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.2,15.2c0-0.3-0.3-0.6-0.6-0.6h-9c-0.3,0-0.6,0.3-0.6,0.6c0,0.3,0.3,0.6,0.6,0.6h9 C25.9,15.8,26.2,15.5,26.2,15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.3,30.1v-8.3c0-0.3-0.3-0.6-0.6-0.6s-0.6,0.3-0.6,0.6v8.3c0,0.6-0.5,1-1,1H6.4c-0.6,0-1-0.5-1-1V3.9 c0-0.6,0.5-1,1-1H21c0.6,0,1,0.5,1,1v1.3c0,0.3,0.3,0.6,0.6,0.6s0.6-0.3,0.6-0.6V3.9c0-1.3-1-2.3-2.3-2.3H6.4 c-1.3,0-2.3,1-2.3,2.3v26.3c0,1.3,1,2.3,2.3,2.3H21C22.3,32.4,23.3,31.4,23.3,30.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.6,27.4h-3.7c-0.3,0-0.6,0.3-0.6,0.6s0.3,0.6,0.6,0.6h3.7c0.3,0,0.6-0.3,0.6-0.6S16,27.4,15.6,27.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4cfa5f755bd1c96223132f599d337bd3.svg";
export { ForwardRef as ReactComponent };